import Component from "react-pure-render/component";
import React from "react";
import Isvg from "react-inlinesvg";
import moment from "moment";
import Griddle from "griddle-react";
import Tooltip from "rc-tooltip";
import Modal from "../components/modal.react";

import { addNotificationsForInvalidFields } from "../lib/validationWeb";

class ActionComponent extends Component {
  openRemoveOrderModal = () => {
    const {
      openRemoveOrderModal
    } = this.props.metadata.customComponentMetadata;
    const { uid } = this.props.rowData;
    openRemoveOrderModal(uid);
  };
  sendOrder() {
    const { onSendOrder } = this.props.metadata.customComponentMetadata;
    const row = this.props.rowData;
    row.status = "awaiting delivery";
    onSendOrder(row, row.uid);
  }
  render() {
    return (
      <div>
        <Tooltip
          placement="bottom"
          trigger={["click", "hover"]}
          overlay={
            <div className="popover">
              <a onTouchTap={this.openRemoveOrderModal}>usuń</a>
              <br />
              <a onTouchTap={this.sendOrder}>wysłano</a>
            </div>
          }
          getTooltipContainer={() => document.getElementById("wrapper")}
        >
          <div className="icon-table link" />
        </Tooltip>
      </div>
    );
  }
}

class NameComponent extends Component {
  render() {
    const { firstName, lastName } = this.props.rowData;
    return (
      <span>
        {firstName} {lastName}
      </span>
    );
  }
}

class ProductsComponent extends Component {
  render() {
    const data = this.props.data;
    const products = data.map(function(item, index) {
      const quantity = item.quantity !== 1 ? ` (${item.quantity} szt)` : "";
      if (index < data.length - 1) {
        return `${item.name + quantity}, `;
      } else {
        return item.name + quantity;
      }
    });

    return <span>{products}</span>;
  }
}

class PriceComponent extends Component {
  render() {
    const data = this.props.rowData.products;
    let price = 0;
    data.forEach(function(item, index) {
      price += item.quantity * item.unitPrice;
    });

    return <span>{(price / 100).toFixed(2)} PLN</span>;
  }
}

class DateComponent extends Component {
  render() {
    const data = moment(new Date(this.props.data)).format("DD.MM.YYYY HH:mm");
    return <span>{data}</span>;
  }
}

class StatusComponent extends Component {
  setPaymentStatus = () => {
    const { paymentStatus, status } = this.props.rowData;
    let statusMsg = "";
    switch (paymentStatus) {
      case 1:
        statusMsg = "płatność nie rozpoczęta";
        break;
      case 2:
        statusMsg = "oczekiwanie na płatność";
        break;
      case 3:
        statusMsg = "oczekiwanie na potwierdzenie płatności";
        break;
      case 4:
        statusMsg = "zapłacono";
        break;
      case 5:
        statusMsg = "anulowano płatność";
        break;
      case 6:
        statusMsg = "odrzucono płatność";
        break;
    }

    if (statusMsg === "zapłacono") {
      statusMsg = "gotowe do wysyłki";
      switch (status) {
        case "awaiting delivery":
          statusMsg = "wysłano";
          break;
        case "delivered":
          statusMsg = "dostarczono";
          break;
        case "canceled":
          statusMsg = "anulowano zamówienie";
          break;
        case "canceled":
        case "cancelled":
          statusMsg = "anulowano";
          break;
        case "complaint":
          statusMsg = "reklamacja";
          break;
      }
    }
    return statusMsg;
  };

  render() {
    const status = this.setPaymentStatus();
    return <span>{status}</span>;
  }
}

export default class Table extends Component {
  static propTypes = {
    actions: React.PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
  }

  openRemoveOrderModal = uid => {
    const { actions } = this.props;
    actions.setIsRemoveOrderModalVisible(uid);
  };

  closeRemoveOrderModal = () => {
    const { actions } = this.props;
    actions.setIsRemoveOrderModalVisible(false);
  };

  removeOrder = () => {
    const {
      actions,
      notificationSystem,
      orders: {
        orders: { isRemoveModalVisible, meta: ordersMeta, sort: ordersSort }
      }
    } = this.props;
    actions.removeOrder(isRemoveModalVisible).then(({ error, payload }) => {
      if (error) {
        addNotificationsForInvalidFields(payload, notificationSystem);
      } else {
        actions.getOrders(ordersMeta, ordersSort).then(({ error, payload }) => {
          if (error) {
            addNotificationsForInvalidFields(payload, notificationSystem);
          }
        });
      }
    });
    actions.setIsRemoveOrderModalVisible(false);
  };

  onSendOrder = (data, uid) => {
    const {
      actions,
      notificationSystem,
      orders: { orders: { meta: ordersMeta, sort: ordersSort } }
    } = this.props;
    actions.updateOrder(data, uid).then(({ error, payload }) => {
      if (error) {
        addNotificationsForInvalidFields(payload, notificationSystem);
      } else {
        actions.getOrders(ordersMeta, ordersSort).then(({ error, payload }) => {
          if (error) {
            addNotificationsForInvalidFields(payload, notificationSystem);
          }
        });
      }
    });
  };

  onRowClick = (row, e) => {
    if (e.target.className !== "icon-table link") {
      const { history } = this.props;
      history.pushState("/orders/:uid", `/orders/${row.props.data.uid}`, {});
    }
  };

  onChangeSort = field => {
    if (field === "name") {
      const {
        actions,
        notificationSystem,
        orders: {
          orders: { search: ordersSearch, meta: ordersMeta, sort: ordersSort }
        }
      } = this.props;
      if (field === "when") {
        field = "whenOccured";
      }
      actions.setOrdersPaginationPage(0);
      let isDirectionAscending = ordersSort.isDirectionAscending;
      if (field === ordersSort.field) {
        isDirectionAscending = !isDirectionAscending;
      }
      actions.setSortOrders(field, isDirectionAscending);
      actions.getOrders(ordersMeta, ordersSort).then(({ error, payload }) => {
        if (error) {
          addNotificationsForInvalidFields(payload, notificationSystem);
        }
      });
    }
  };

  render() {
    const {
      config,
      actions,
      tableWidth,
      tableHeight,
      orders: {
        orders: {
          isRemoveModalVisible,
          loading,
          entities: orders,
          meta: { currentPage, limit },
          sort
        }
      }
    } = this.props;

    let columnMetadata = [
      {
        columnName: "index",
        displayName: "Lp.",
        cssClassName: "table-unsortable",
        visible: true
      },
      {
        columnName: "name",
        displayName: "Kontrahent",
        cssClassName: "table-unsortable",
        visible: true,
        customComponent: NameComponent
      },
      {
        columnName: "products",
        displayName: "Produkty",
        cssClassName: "table-unsortable",
        visible: true,
        customComponent: ProductsComponent
      },
      {
        columnName: "price",
        displayName: "Cena",
        cssClassName: "table-unsortable",
        visible: true,
        customComponent: PriceComponent
      },
      {
        columnName: "status",
        displayName: "Status",
        cssClassName: "table-unsortable",
        visible: true,
        customComponent: StatusComponent
      },
      {
        columnName: "createdAt",
        displayName: "Data zamówienia",
        cssClassName: "table-unsortable",
        visible: true,
        customComponent: DateComponent
      },
      {
        columnName: "actions",
        displayName: "Akcje",
        visible: true,
        cssClassName: "data-table-file table-unsortable",
        customComponent: ActionComponent,
        customComponentMetadata: {
          openRemoveOrderModal: this.openRemoveOrderModal,
          onSendOrder: this.onSendOrder
        }
      }
    ];

    let data = [];
    let index = 0;

    if (orders) {
      orders
        .sort(
          (a, b) =>
            new Date(b.get("createdAt")).getTime() -
            new Date(a.get("createdAt")).getTime()
        )
        .forEach(function(order) {
          order = order.toJS();
          index++;
          order.index = index + currentPage * limit;
          order.status = order.status ? order.status : "";
          data = data.concat(order);
        });
    }

    return (
      <div>
        <Griddle
          results={data}
          columnMetadata={columnMetadata}
          tableClassName="data-table"
          useGriddleStyles={false}
          columns={[
            "index",
            "name",
            "products",
            "price",
            "status",
            "createdAt",
            "actions"
          ]}
          onRowClick={this.onRowClick}
          enableSort={false}
          enableInfiniteScroll={false}
          showPager={false}
          bodyHeight={tableHeight}
          resultsPerPage={100}
          useExternal={true}
          externalChangeSort={this.onChangeSort}
          externalSortColumn={sort.field}
          externalSortAscending={sort.isDirectionAscending}
          externalSetPage={() => {}}
          externalSetFilter={() => {}}
          externalSetPageSize={() => {}}
          externalMaxPage={() => {}}
          externalCurrentPage={() => {}}
          noDataMessage={loading ? "trwa ładowanie danych..." : "Brak danych"}
          sortAscendingComponent={
            <Isvg className="fa fa-sort-asc" src="/assets/img/icon_sort.svg" />
          }
          sortDescendingComponent={
            <Isvg className="fa fa-sort-desc" src="/assets/img/icon_sort.svg" />
          }
        />
        {isRemoveModalVisible && (
          <Modal
            closeModalAction={this.closeRemoveOrderModal}
            enterAction={this.removeOrder}
            handleKeyDownEvent={true}
          >
            <div className="row">
              <h3 className="col-xs-12">Potwierdź usunięcie</h3>
              <div className="col-xs-12">
                <p>Czy napewno usunąć?</p>
                <button className="error" onClick={this.removeOrder}>
                  Usuń
                </button>
              </div>
            </div>
          </Modal>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/browser/orders/table.react.js